import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import {
  UpdatePaymentMethodToDefaultParams,
  updatePaymentMethodToDefault,
} from '@utils/backend-api/stripe';

export default function useSetPaymentMethodToDefault() {
  const { mutate, mutateAsync, isLoading } = useMutation(
    (values: UpdatePaymentMethodToDefaultParams) => updatePaymentMethodToDefault(values),
    {
      onSuccess: () => {
        toast.success('Payment method has been updated');
      },
      onError: () => {
        toast.error('Payment method was not saved, please try again.');
      },
    }
  );

  return {
    mutate,
    mutateAsync,
    isLoading,
  };
}
